import Vue from 'vue';
import {
    GET_SYSTEM_AUTH_TPL_REQUEST,
    GET_SYSTEM_AUTH_TPL_SUCCESS,
    GET_SYSTEM_AUTH_TPL_FAILURE
} from '../mutationTypes';

const state = {
    systemTemplate: [],
    loading: false,
};
const mutations = {
    [GET_SYSTEM_AUTH_TPL_REQUEST](state) {
        state.loading = true;
    },
    [GET_SYSTEM_AUTH_TPL_SUCCESS](state, res) {
        state.systemTemplate = res.reverse();
        state.loading = false;
    },
    [GET_SYSTEM_AUTH_TPL_FAILURE](state) {
        state.loading = false;
    }
};

export const actions = {
    async getSystemAuthpl({ commit }) {
        commit(GET_SYSTEM_AUTH_TPL_REQUEST);

        const res = await Vue.$ajax.get('authTpl');

        if (!res.errorType) {
            commit(GET_SYSTEM_AUTH_TPL_SUCCESS, res);
        } else {
            commit(GET_SYSTEM_AUTH_TPL_FAILURE);
        }
    }
};

export default {
    state,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/roleEdit.js